import React, { useState, useEffect } from "react";
import { Form, Dropdown } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import { Activity, Area } from "../../../../api";
import { useAuth } from "../../../../hooks";

const activityController = new Activity();
const areaController = new Area();

export function ActivityForm({ activity, close, onReload }) {
  const { accessToken } = useAuth();
  const [areaOptions, setAreaOptions] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const areas = await areaController.getAreas(accessToken, true);
        setAreaOptions(areas.map((a) => ({ key: a._id, text: `${a.code} - ${a.name}`, value: a._id })));
      } catch {
        setAreaOptions([]);
      }
    })();
  }, []);

  const formik = useFormik({
    initialValues: {
      code: activity?.code || "",
      name: activity?.name || "",
      area: activity?.area?._id || activity?.area || "",
    },
    validationSchema: Yup.object({
      code: Yup.string(),
      name: Yup.string().required("El nombre es requerido"),
      area: Yup.string().required("El área es requerida"),
    }),
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        if (activity) {
          await activityController.updateActivity(accessToken, activity._id, values);
          toast.success("Actividad actualizada");
        } else {
          await activityController.createActivity(accessToken, values);
          toast.success("Actividad creada");
        }
        onReload();
        close();
      } catch (err) {
        toast.error(err?.msg || "Error al guardar");
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <Form onSubmit={formik.handleSubmit} style={{ padding: "0.5rem" }}>
      <ToastContainer position="top-center" autoClose={800} hideProgressBar />
      <Form.Input
        label={<><span style={{ fontWeight: "bold" }}>Código</span></>}
        name="code"
        value={formik.values.code}
        onChange={(e) => {
          const v = e.target.value;
          formik.setFieldValue("code", v.length > 0 ? v.charAt(0).toUpperCase() + v.slice(1).toLowerCase() : v);
        }}
        error={formik.errors.code}
        placeholder="Ej: Act-001"
      />
      <Form.Field error={!!formik.errors.area}>
        <label><span style={{ fontWeight: "bold" }}>Área</span> <span style={{ color: "red" }}>*</span></label>
        <Dropdown
          placeholder="Seleccionar área"
          fluid
          selection
          search
          upward
          options={areaOptions}
          value={formik.values.area}
          onChange={(_, { value }) => formik.setFieldValue("area", value)}
        />
        {formik.errors.area && (
          <div className="ui pointing above prompt label">{formik.errors.area}</div>
        )}
      </Form.Field>
      <Form.Input
        label={<><span style={{ fontWeight: "bold" }}>Nombre</span> <span style={{ color: "red" }}>*</span></>}
        name="name"
        value={formik.values.name}
        onChange={(e) => {
          const v = e.target.value;
          formik.setFieldValue("name", v.length > 0 ? v.charAt(0).toUpperCase() + v.slice(1) : v);
        }}
        error={formik.errors.name}
        placeholder="Ej: Monitoreo de emisiones"
      />
      <div style={{ display: "flex", justifyContent: "center", gap: "14px", marginTop: "2rem" }}>
        <button type="submit" disabled={formik.isSubmitting} style={{ background: "#4A7FA5", color: "#fff", border: "none", borderRadius: "20px", padding: "10px 30px", fontSize: "14px", fontWeight: 600, fontFamily: "'Archivo', sans-serif", cursor: "pointer", opacity: formik.isSubmitting ? 0.55 : 1 }}>
          {formik.isSubmitting ? "…" : (activity ? "Actualizar" : "Guardar")}
        </button>
        <button type="button" onClick={close} style={{ background: "#9BAFC4", color: "#fff", border: "none", borderRadius: "20px", padding: "10px 30px", fontSize: "14px", fontWeight: 600, fontFamily: "'Archivo', sans-serif", cursor: "pointer" }}>
          Cancelar
        </button>
      </div>
    </Form>
  );
}
